import type { DraftDealProduct } from './vehicleProtectionTypes';
import type { OfferType } from '@makemydeal/dr-platform-types';

export const FALLBACK_TO_TARGET_PRODUCTS_COUNT = 5;

export type DealTemplateInventoryTypeExtended = 'New' | 'Used' | 'CertifiedPreOwned' | 'All';
export type DealTemplateInventoryType = Omit<DealTemplateInventoryTypeExtended, 'All'> | null;

export type DraftDealTemplate = {
    id: string;
    overwritten: boolean;
    name: string;
    inventoryType?: DealTemplateInventoryType;
    make?: string | null;
    isError: boolean;
    isSaving: boolean;
    isSaved: boolean;
    errorDetails?: {
        name: string;
        message: string;
    };
};

export type AppliedDealTemplate = {
    id: string;
    name: string;
    scenariosCount: number;
};

export type DealTemplate = {
    id: string;
    dealerId?: number;
    make?: string;
    name: string;
    createdByName: string;
    createdAt: string;
    updatedByName?: string;
    updatedAt?: string;
    isAutoApply: boolean;
    isManualApply: boolean;
    description?: string;
    inventoryType?: DealTemplateInventoryType;
    inventoryTypes?: DealTemplateInventoryType[] | null;
    makes?: string[] | null;
    models?: string[] | null;
    trims?: string[] | null;
    years?: number[] | null;
    configurations?: string[] | null;
    scenariosCount?: number;
};

export type DealTemplateList = {
    value: DealTemplate[];
    isLoading: boolean;
    isError: boolean;
};

export type DataToRemoveTemplate = {
    id: string;
    name: string;
    inventoryType?: DealTemplateInventoryType;
};

export type RemovingDealTemplate = {
    id: string;
    name: string;
    isError: boolean;
    isRemoving: boolean;
    isRemoved: boolean;
    inventoryType?: DealTemplateInventoryTypeExtended;
};

export type DataToUpdateTemplate = {
    id: string;
    name?: string;
    isAutoApply?: boolean;
    isManualApply?: boolean;
    forceAutoApply?: boolean;
    description?: string;
    inventoryTypes?: DealTemplateInventoryType[] | null;
    makes?: string[] | null;
    models?: string[] | null;
    trims?: string[] | null;
    years?: number[] | null;
    configurations?: string[] | null;
};

export type DealTemplateUpdateConflictError = {
    id: string;
    name: string;
};

export type UpdatingDealTemplate = {
    id: string;
    isError: boolean;
    isUpdating: boolean;
    isUpdated: boolean;
    name: string;
    inventoryType?: DealTemplateInventoryTypeExtended;
    errorDetails?: {
        name: string;
        message: string;
        errors: DealTemplateUpdateConflictError[];
    };
};

export type ManualTemplateApplySource = 'firstPencil';

export type ApplyingDealTemplate = {
    id: string;
    name: string;
    isError: boolean;
    isApplying: boolean;
    isApplied: boolean;
    source?: ManualTemplateApplySource;
};

export type DealTemplatesState = {
    draft: DraftDealTemplate;
    applied: AppliedDealTemplate;
    applying: {
        products?: DraftDealProduct[];
        isOriginalTemplateProductsApplied?: boolean;
    };
    list: DealTemplateList;
    manualList: DealTemplateList;
    removing: RemovingDealTemplate;
    savePaymentTerms: boolean;
    updating: UpdatingDealTemplate;
    templateBuilderMode: {
        show: boolean;
        builderModeTab: 'manage-existing-templates' | 'save-template';
    };
    manuallyApplying: ApplyingDealTemplate;
};

export type ParamsToSaveTemplate = {
    name: string;
    description?: string;
    inventoryType?: 'New' | 'Used' | 'CertifiedPreOwned' | null;
    make?: string | null;
    isAutoApply?: boolean;
    isManualApply?: boolean;
    inventoryTypes?: DealTemplateInventoryType[] | null;
    years?: number[] | null;
    makes?: string[] | null;
    models?: string[] | null;
    trims?: string[] | null;
    configurations?: string[] | null;
    selectedScopeIds?: string[];
};

export type ScenarioVehicleDetail = {
    scopeId: string;
    offerType?: OfferType;
    isPrimary: boolean;
    year?: number;
    make?: string;
    model?: string;
    trim?: string;
    term?: number | null;
    monthlyPayment?: number | null;
    rate?: number;
    rateType?: string;
};
